export const LOAD_DOORS = 'LOAD_DOORS'